/* @flow */
import * as React from "react";
import styled from "styled-components";
import ClickOutside from "../common/ClickOutside";
import AnimationWrapper from "../AnimationWrapper";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 2.5em;
  font-size: 10px;
  line-height: 1;
  background-color: rgba(0, 0, 0, 0.5);
  user-select: none;
  z-index: 20000;

  @media (max-width: 959px) {
    padding: 1.5em;
    font-size: 8px;
  }
  @media (max-width: 568px) {
    font-size: 7px;
  }
`;

const Popup = styled.div`
  position: relative;
  flex-shrink: 1;
  width: 100%;
  max-width: 74em;
  max-height: 100%;
  margin: 0 auto;
  text-align: center;
  background-color: ${({ theme }) => theme.popupBackground};
  border-radius: 0.5em;
  box-shadow: 0 0 17px 0 rgba(0, 0, 0, 1);

  @media (max-width: 959px) {
    max-width: 50em;
  }
`;

const Close = styled.div`
  position: absolute;
  top: 18px;
  right: 18px;
  width: 18px;
  height: 18px;
  color: #a0a7b2;
  background-size: cover;
  transition: all 0.15s ease;
  cursor: pointer;
  z-index: 1;

  :before,
  :after {
    content: "";
    position: absolute;
    top: -1px;
    left: 50%;
    width: 0;
    height: 24px;
    border-left: 2px solid;
  }

  :before {
    transform: translateX(-50%) rotate(45deg);
    transform-origin: 100%;
  }

  :after {
    transform: translateX(-50%) rotate(-45deg);
    transform-origin: 0%;
  }

  :hover {
    color: #60a31c;
  }

  @media (max-width: 959px) {
    top: 14px;
    right: 14px;
    width: 26px;
    height: 26px;

    :before,
    :after {
      top: -4px;
      height: 36px;
    }
  }
`;

type Props = {
  onDismiss: () => void,
  children: any,
  className?: string,
  disableOutside?: boolean,
  key?: number
};

function Modal(props: Props) {
  return (
    <Overlay key={props.key}>
      <ClickOutside
        onOutsideClick={props.disableOutside ? null : props.onDismiss}
      >
        {({ innerRef }) => (
          <AnimationWrapper>
            <Popup ref={innerRef} className={props.className}>
              <Close onClick={props.onDismiss} />
              {props.children}
            </Popup>
          </AnimationWrapper>
        )}
      </ClickOutside>
    </Overlay>
  );
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/TradeModals/Modal.js